
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FeedbackService } from '../../services/feedback.service';
import { UsersService } from '../../services/user.service';
import { User } from '../../models/user';
import { P } from '@angular/cdk/keycodes';
import { Feedback } from '../../models/feedback';
import { delay, Subscription, tap } from 'rxjs';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmFeedbackComponent } from '../../dialogs/confirm-feedback/confirm-feedback.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-feedback',
  imports: [
    MatInputModule, 
    CommonModule,
    MatFormFieldModule, 
    FormsModule, 
    MatButtonModule, 
    MatSelectModule, 
    MatSnackBarModule,
    MatIcon
  ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss'
})
export class FeedbackComponent {
  feedbackService = inject(FeedbackService);
  userService = inject(UsersService);
  snackbar = inject(MatSnackBar);
  feedback = "";
  feedbackType = null;
  placeholder = "";
  user?: User;
  feedbacks?: Feedback[];
  feedbackSub: Subscription;
  readonly dialog = inject(MatDialog);
  
  constructor() {
    this.userService.getCurrentUser().subscribe(u => 
      this.user = u
    );
    this.feedbackSub = this.feedbackService.filterfeedback([]).subscribe(f => {
      this.feedbacks = f.feedback;
    });
  }

  ngOnDestroy() {
    this.feedbackSub.unsubscribe();
  }

  addFeedback() {
    if (! this.user) {
      console.error("User is not set.");
    }
    this.feedbackService
      .addFeedback({ 
        feedback: this.feedback, 
        type: this.feedbackType ?? 'other', 
        userAgent: navigator.userAgent, 
        roleIdsWhenSubmitting: this.user?.userRoles?.map(ur => ur.roleId).join(',') ?? 'None', 
        userId: this.user!.id  
      })
      //.pipe(delay(3000), tap(_ => this.feedback = ""))
      .subscribe({ next: _ => {
        // this.snackbar.open("Your feedback was successfully posted.", undefined, 
        //   { 
        //     verticalPosition: 'top', duration: 3000     
        //   });
          this.dialog.open(ConfirmFeedbackComponent, {
              width: '600px',
          })
        } 
      });  
      this.feedback = "";
      this.feedbackType = null;
      console.log(this.feedback);
       
      };
  }
      // .addFeedback({ 
      //   feedback: this.feedback, 
      //   type: this.feedbackType ?? 'other', 
      //   userAgent: navigator.userAgent, 
      //   roleIdsWhenSubmitting: this.user?.userRoles?.map(ur => ur.roleId).join(',') ?? 'None', 
      //   userId: this.user!.id  
      // })
      // .pipe(delay(3000), tap(_ => this.feedback = ""))
      // .subscribe({ next: _ => {
      //    this.snackbar.open("Your feedback was successfully posted.", undefined, { verticalPosition: 'top', duration: 3000 });